import { render, staticRenderFns } from "./SiteNavDesktopTopItem.vue?vue&type=template&id=d8877c28&scoped=true&lang=pug&"
import script from "./SiteNavDesktopTopItem.vue?vue&type=script&lang=js&"
export * from "./SiteNavDesktopTopItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavDesktopTopItem.vue?vue&type=style&index=0&id=d8877c28&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8877c28",
  null
  
)

export default component.exports